const metrics = [
  {
    title: 'Отработано часов',
    metric: {
      value: 'number_of_working_hours',
      icon: 'clock-o',
    },
  },
  {
    title: 'Забыто закрыть смен',
    metric: {
      value: 'auto_ended_shifts',
      icon: 'close',
    },
  },
  {
    title: 'Изготовлено продукции',
    metric: {
      value: 'ended_products',
      icon: 'female',
    },
  },
  {
    title: 'Смены всех сотрудников',
    metric: {
      icon: 'file-text',
    },
  },
];

export const personalArea = {
  metrics,
};



// WEBPACK FOOTER //
// ./src/user/constants/personalArea.js